// extracted by mini-css-extract-plugin
export default {"items_container":"SocketIntegration_items_container__G0fzr","item":"SocketIntegration_item__jeEzG","idle":"SocketIntegration_idle__2nKDE"};